import { getFieldNames } from './getFieldNames';
import * as organization from './organization';
import * as user from './user';

export const services = { getFieldNames, organization, user };
